
import Vue from 'vue';
import Component from 'vue-class-component';
import { mm2px } from '@/helper/unitHelper';

@Component({
    props: {
        mmWidth: {
            type: Number,
            required: true,
        },
        mmHeight: {
            type: Number,
            required: true,
        },
    },
})
export default class DocumentPageCanvas extends Vue {
    // 印刷は96dpiだがラベル屋さんの内部では72dpi

    public get viewWidth(): number {
        return mm2px(this.$props.mmWidth, 72);
    }

    public get viewHeight(): number {
        // 印刷範囲を調整するため高さを削る
        return mm2px(this.$props.mmHeight - 1, 72);
    }

    private get viewBox(): string {
        return `0 0 ${this.viewWidth} ${this.viewHeight}`;
    }

    public get printWidth(): number {
        return mm2px(this.$props.mmWidth, 96);
    }

    public get printHeight(): number {
        // 印刷範囲を調整するため高さを削る
        return mm2px(this.$props.mmHeight - 1, 96);
    }
}
